import * as React from 'react';

import {
  Colors,
} from '@bluecurrent/web-component-lib';

export default function Divider({
  isSolid = false,
}) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          height: isSolid ? 15 : 10,
          minWidth: 0,
          borderLeft: `solid 4px ${Colors.MEDIUM_GREY}`,
        }}
      />
      <div
        style={{
          height: isSolid ? 20 : 25,
          minWidth: 0,
          borderLeft: `${isSolid ? 'solid' : 'dashed'} 4px ${Colors.MEDIUM_WHITE}`,
        }}
      />
    </div>
  );
}
